"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defekt = void 0;
const formatErrorMessage_1 = require("./formatErrorMessage");
const defekt = function ({ code, defaultMessage }) {
    var _a;
    return _a = class extends Error {
            constructor(messageOrMetadata = {}) {
                var _a, _b;
                super(typeof messageOrMetadata === 'string' ?
                    messageOrMetadata :
                    (_b = (_a = messageOrMetadata.message) !== null && _a !== void 0 ? _a : defaultMessage) !== null && _b !== void 0 ? _b : `${formatErrorMessage_1.formatErrorMessage({ code })}`);
                this.code = code;
                if (typeof messageOrMetadata !== 'string') {
                    this.cause = messageOrMetadata.cause;
                    this.data = messageOrMetadata.data;
                }
            }
        },
        _a.code = code,
        _a;
};
exports.defekt = defekt;
